import { render, staticRenderFns } from "./modalCoSignandSave.vue?vue&type=template&id=a87fa202&"
import script from "./modalCoSignandSave.vue?vue&type=script&lang=js&"
export * from "./modalCoSignandSave.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports